import { FC, ReactNode } from 'react';

import useMedia from '@zvuk-b2b/react-uikit/toolkit/useMedia';

import { TEXTS } from './texts';
import DiscountHint from './DiscountHint/DiscountHint';

import styles from './PrimeDiscount.module.scss';

interface PrimeDiscountProps {
  primeDiscountValue?: number | null;
  children?: ReactNode | undefined;
}

const PrimeDiscount: FC<PrimeDiscountProps> = ({ children, primeDiscountValue }) => {
  const { isDesktop } = useMedia();

  if (!primeDiscountValue) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.discount}>
        <div className={styles.discountPriceBlock}>
          <div className={styles.discountDescription}>{TEXTS.PRIME_POINT_COUNT}</div>
          <div>
            <span className={styles.oldPrice}>{children}</span>
            <span className={styles.newPrice}>{`${primeDiscountValue} ${TEXTS.PRIME_PRICE} `}</span>
            <span>{TEXTS.PRIME_MONTH}</span>
          </div>
        </div>

        {!isDesktop && <DiscountHint />}
      </div>

      {isDesktop && <DiscountHint />}
    </div>
  );
};

export default PrimeDiscount;
